__turbopack_context__.v({
  "article": "Blog-module__9Djs7q__article",
  "articleHeader": "Blog-module__9Djs7q__articleHeader",
  "articleMeta": "Blog-module__9Djs7q__articleMeta",
  "backLink": "Blog-module__9Djs7q__backLink",
  "container": "Blog-module__9Djs7q__container",
  "contentImage": "Blog-module__9Djs7q__contentImage",
  "contentImageBody": "Blog-module__9Djs7q__contentImageBody",
  "contentImageCaption": "Blog-module__9Djs7q__contentImageCaption",
  "contentImageFrame": "Blog-module__9Djs7q__contentImageFrame",
  "emptyState": "Blog-module__9Djs7q__emptyState",
  "emptyText": "Blog-module__9Djs7q__emptyText",
  "emptyTitle": "Blog-module__9Djs7q__emptyTitle",
  "postBody": "Blog-module__9Djs7q__postBody",
  "postCard": "Blog-module__9Djs7q__postCard",
  "postCardCover": "Blog-module__9Djs7q__postCardCover",
  "postCategory": "Blog-module__9Djs7q__postCategory",
  "postContainer": "Blog-module__9Djs7q__postContainer",
  "postCoverFrame": "Blog-module__9Djs7q__postCoverFrame",
  "postExcerpt": "Blog-module__9Djs7q__postExcerpt",
  "postGrid": "Blog-module__9Djs7q__postGrid",
  "postLink": "Blog-module__9Djs7q__postLink",
  "postMeta": "Blog-module__9Djs7q__postMeta",
  "postTitle": "Blog-module__9Djs7q__postTitle",
  "richText": "Blog-module__9Djs7q__richText",
});
